import { release } from '@awayfl/swf-loader';
export var TRAITNames = ['Slot', 'Method', 'Getter', 'Setter', 'Class', 'Function', 'Const', 'GetterSetter'];
export function getTRAITName(trait) {
    return release ? String(trait) : TRAITNames[trait];
}
